// Public catalog endpoints: mentors, categories, spreads, stardust packs.
// All are unauthenticated reads; stardust checkout is authed.

import { call } from './core';
import type {
  Category,
  CheckoutResult,
  Mentor,
  Spread,
  StardustPack,
} from './types';

export const catalogApi = {
  mentors: () => call<Mentor[]>('/mentors', { auth: false }),
  categories: () => call<Category[]>('/categories', { auth: false }),
  spreads: () => call<Spread[]>('/spreads', { auth: false }),

  // STA-149 — Stardust packs (public catalog + authed checkout).
  stardustPacks: () => call<StardustPack[]>('/stardust/packs', { auth: false }),
  buyStardustPack: (
    pack_id: string,
    params: {
      provider?: 'newebpay' | 'stripe';
      return_url?: string;
      refund_policy_agreed: boolean;
    },
  ) =>
    call<CheckoutResult & { provider: string }>(
      `/stardust/packs/${encodeURIComponent(pack_id)}/checkout`,
      { method: 'POST', body: JSON.stringify(params) },
    ),
};
